import { ANALYTICS_DISABLED } from '@/config/analytics';

const RAW_COUNTER = process.env.VUE_APP_METRIKA_COUNTER_ID || '108578447';
export const YANDEX_METRIKA_COUNTER_ID = Number.parseInt(String(RAW_COUNTER).replace(/\D/g, ''), 10) || 108578447;

/** Имена целей из кабинета Метрики (rice.ru). */
const YM_OFFICIAL_GOALS = new Set([
  'Go',
  'SignUp_Cancel',
  'SignUp_SentForm_Success',
  'SignIn_SentForm_Success',
  'Check_Click',
  'Check_Download_Success',
  'Feedback_SentForm_Success',
  'Rules_Click',
  'Play',
  'Start',
  'Download',
]);

/** Внутренние имена из кода → имя цели в Метрике. */
const CODE_TO_YM_GOAL = {
  click_upload_check_main: 'Check_Click',
  click_upload_check_profile: 'Check_Click',
  upload_check_succes: 'Check_Download_Success',
};

const TOP100_TRACKED_GOALS = new Set([
  'upload_check_succes',
  'registration_succes',
  'click_upload_check_main',
  'click_tg_main',
]);

const TOP100_GOAL_ALIASES = {
  click_upload_check_profile: 'click_upload_check_main',
  click_tg_profile: 'click_tg_main',
};

function toYmGoalName(goal) {
  if (YM_OFFICIAL_GOALS.has(goal)) {
    return goal;
  }
  return CODE_TO_YM_GOAL[goal] || null;
}

function sendTop100Goal(goal) {
  if (typeof window === 'undefined') {
    return;
  }
  const top100Goal = TOP100_GOAL_ALIASES[goal] || goal;
  if (!TOP100_TRACKED_GOALS.has(top100Goal)) {
    return;
  }
  const counter = window.top100Counter;
  if (!counter || typeof counter.trackEvent !== 'function') {
    return;
  }
  try {
    counter.trackEvent(top100Goal);
  } catch (e) {
    // noop
  }
}

export function isMetrikaAvailable() {
  return !ANALYTICS_DISABLED && typeof window !== 'undefined' && typeof window.ym === 'function';
}

/**
 * Просмотр страницы в SPA (первый показ приходит из счётчика в index.html).
 */
export function metrikaHit(url) {
  if (!isMetrikaAvailable()) {
    return;
  }
  const hitUrl = url || window.location.pathname + window.location.search;
  try {
    window.ym(YANDEX_METRIKA_COUNTER_ID, 'hit', hitUrl, {
      title: typeof document !== 'undefined' ? document.title : '',
      referer: typeof document !== 'undefined' ? document.referrer : '',
    });
  } catch (e) {
    // noop
  }
}

export function sendMetrik(event, goal) {
  if (typeof window === 'undefined') {
    return;
  }

  if (event === 'reachGoal') {
    sendTop100Goal(goal);
    const ymGoal = toYmGoalName(goal);
    if (!ymGoal || !isMetrikaAvailable()) {
      return;
    }
    try {
      window.ym(YANDEX_METRIKA_COUNTER_ID, event, ymGoal);
    } catch (e) {
      // noop
    }
    return;
  }

  if (ANALYTICS_DISABLED || typeof window.ym !== 'function') {
    return;
  }

  try {
    window.ym(YANDEX_METRIKA_COUNTER_ID, event, goal);
  } catch (e) {
    // noop
  }
}

export function initMetrikaAutoGoals() {
  if (typeof window === 'undefined' || window.__riceMetrikaAutoGoalsInited) {
    return;
  }
  window.__riceMetrikaAutoGoalsInited = true;

  if (!isMetrikaAvailable()) {
    return;
  }

  const reached = {
    scroll25: false,
    scroll50: false,
    scroll75: false,
    scroll100: false,
  };

  const onScroll = () => {
    const documentEl = document.documentElement;
    const body = document.body;
    const scrollTop = window.scrollY || documentEl.scrollTop || body.scrollTop || 0;
    const scrollHeight = Math.max(
      body.scrollHeight,
      documentEl.scrollHeight,
      body.offsetHeight,
      documentEl.offsetHeight,
      body.clientHeight,
      documentEl.clientHeight
    );
    const viewportHeight = window.innerHeight || documentEl.clientHeight || 0;
    const denominator = Math.max(1, scrollHeight - viewportHeight);
    const percent = (scrollTop / denominator) * 100;

    if (!reached.scroll25 && percent >= 25) {
      reached.scroll25 = true;
      sendMetrik('reachGoal', 'scroll25');
    }
    if (!reached.scroll50 && percent >= 50) {
      reached.scroll50 = true;
      sendMetrik('reachGoal', 'scroll50');
    }
    if (!reached.scroll75 && percent >= 75) {
      reached.scroll75 = true;
      sendMetrik('reachGoal', 'scroll75');
    }
    if (!reached.scroll100 && percent >= 99) {
      reached.scroll100 = true;
      sendMetrik('reachGoal', 'scroll100');
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  window.setTimeout(() => sendMetrik('reachGoal', '15sek'), 15000);
  window.setTimeout(() => sendMetrik('reachGoal', '60sek'), 60000);
}
